import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";
import { useRef } from "react";

/**
 *
 * If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
 * Unfortunately, in order for <Draggable> to work properly, we need raw access
 * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
 * see: https://github.com/react-grid-layout/react-draggable/blob/v4.4.2/lib/DraggableCore.js#L159-L171
 */
const DraggableComponent = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      bounds={{ top: 0 }}
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
};

export default DraggableComponent;
